import { MdChevronLeft, MdClose } from "react-icons/md";

import { Button, Stack, Text, usePopoverContext } from "@chakra-ui/react";
import { rem } from "polished";

import { CheckboxOptionType } from "../checkbox-select-list/types";

type MultiSelectToggleProps<T extends string> = {
  onClear: React.MouseEventHandler<HTMLButtonElement>;
  label: string;
  pluralLabel: string;
  selectedOptions: CheckboxOptionType<T>[];
};

export const MultiSelectToggle = <T extends string>({
  selectedOptions,
  onClear,
  label,
  pluralLabel,
  ...props
}: MultiSelectToggleProps<T>) => {
  const { open } = usePopoverContext();

  return (
    <Button
      {...props}
      paddingInline={2}
      paddingBlock={1}
      borderRadius={6}
      backgroundColor={selectedOptions.length > 0 ? "blue.500" : "white"}
      color={selectedOptions.length > 0 ? "white" : "gray.900"}
      size="sm"
      variant="outline"
    >
      <Stack direction="row" alignItems="center">
        <Text fontWeight={600}>
          {selectedOptions.length === 0 && label}
          {selectedOptions.length === 1 && selectedOptions[0].label}
          {selectedOptions.length > 1 && `${selectedOptions.length} ${pluralLabel}`}
        </Text>
        {selectedOptions.length !== 0 ? (
          <span onClick={onClear}>
            <MdClose size={rem(16)} />
          </span>
        ) : (
          <span>
            <MdChevronLeft style={{ transform: `rotate(${open ? 90 : -90}deg)` }} size={rem(16)} />
          </span>
        )}
      </Stack>
    </Button>
  );
};
